import type { Infer } from 'superstruct';
import { boolean, object, optional, string, trimmed } from 'superstruct';

import { email } from '@adflow/shared/util-superstruct';

export const EditUserDto = object({
	name: optional(trimmed(string())),
	email: optional(email()),
	archived: optional(boolean()),
	superuser: optional(boolean()),
});

export type EditUserDto = Infer<typeof EditUserDto>;
